module.exports = __webpack_public_path__ + "img/play-phone-2.9ac96bd1.png";